import { StatusWithAddressAndNoHome } from '../../constants/statusWithAddressAndNoHome'
import type { ActiveOrderType } from '../../types/activePurchases.types'
import { DeliveryMethods } from '../../types/purchases.types'
import { purchaseStatusInfo } from '../purchaseStatusInfo/purchaseStatusInfo'

export function getAddres({ lastOrder }: { lastOrder: ActiveOrderType }) {
	if (!purchaseStatusInfo[lastOrder.status].showAddress) {
		return null
	}
	const { deliveryMethod, delivery } = lastOrder

	const address = `${delivery.fullAddress} ${delivery.city} ${delivery.zipCode}`

	if (
		!(
			deliveryMethod === DeliveryMethods.dropPoint ||
			deliveryMethod === DeliveryMethods.store
		)
	) {
		return address
	}

	if (lastOrder.status in StatusWithAddressAndNoHome) {
		return address
	}

	return null
}
